import { z } from 'zod';
import i18n from '@/i18n';

export const filterProfileSchema = z.object({
    min_age: z.number(),
    max_age: z.number(),
    // @ts-ignore
    looks_for: z.enum(['male', 'female', 'any'], { message: i18n.t('gender_required') }),
    //region: z.object({ label: z.string(), value: z.number() }).nullable(),
    regions: z.array(z.object({ label: z.string(), value: z.number() })),
});

export type FilterProfileSchemaType = z.infer<typeof filterProfileSchema>;
